export default __webpack_public_path__ + "files/WaltonFamily-1cc5110875e2e0da51ab14bd951acc44.png";